import React, { useEffect } from 'react'
import { PrismLight  as SyntaxHighlighter } from 'react-syntax-highlighter';
import { oneDark  } from 'react-syntax-highlighter/dist/esm/styles/prism';
import {HiClipboard} from 'react-icons/hi'

import './CodeBlock.css'
import { useCopyToClipboard } from 'react-use';
import toast from 'react-hot-toast';

export function CodeBlock({ code , pureCode , language }) {


	const [state, copyToClipboard] = useCopyToClipboard();

	useEffect(() => {

		async function processTasks(){
			if(state?.error) toast.error('Not copied!' ,{ position : 'bottom-right'});
			else if(state?.value) toast.success('Copied!' , {
				position: "bottom-right"
			})
		}

		processTasks();

	}, [state])

	return (
		<div className='codeblock-content'>
			<span 
				className="copyContent-btn" 
				title='Copy to clipboard'
				onClick={ () => copyToClipboard(pureCode ?? code)}><HiClipboard /></span>
			<SyntaxHighlighter 
				language={language}
				style={oneDark }
				showLineNumbers={true}
				// wrapLines={true}
				>{code}</SyntaxHighlighter>
		</div>
	)
}
